export default __webpack_public_path__ + "static/media/widget_watchbox_vpmspx1d_buy.681cb564.mp3";